import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type Contract = {
  contractid: string;
  contractname: string;
  contractcode: string;
  contractdesc: string;
  uidisplay: boolean;
};

const getContracts = async (
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ contracts: Contract[]; totalPages: number }> => {
  const response = await fetch(`/api/contracts?q=${searchQuery}&limit=${limit}&page=${page}`);
  return response.json();
};

export const CONTRACTS_QUERY_KEY = 'contracts';

export const useContracts = ({
  searchQuery,
  page,
  limit = 5,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [CONTRACTS_QUERY_KEY, searchQuery, page, limit],
    queryFn: () => getContracts(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });
